export default {"src":"/_next/static/media/HIMS.9fdee638.svg","height":18,"width":18};